import { Component } from '@angular/core';

@Component({
  selector: 'app-fee-home',
  templateUrl: './fee-home.component.html',
  styleUrls: ['./fee-home.component.css']
})
export class FeeHomeComponent {

}
